import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { Button } from '@v2/components';
import { SubOfferingRowProps } from './types';
import { styles } from './styles';

const SubOfferingRow: React.FC<SubOfferingRowProps> = ({
  entityName,
  displayNameInput,
  onDelete,
  deleteAriaLabel = 'Delete sub offering',
  deleteDisabled,
}) => (
  <li className={styles.container}>
    <div className={styles.header}>
      <div>
        <div className={styles.entityLabel}>Entity name</div>
        <div className={styles.entityValue}>{entityName}</div>
      </div>
      <div className={styles.deleteButton}>
        <Button
          variant="ghost"
          size="sm"
          onClick={onDelete}
          disabled={deleteDisabled}
          icon={<FontAwesomeIcon icon={faTrash} />}
          aria-label={deleteAriaLabel}
          className={styles.deleteIcon}
        />
      </div>
    </div>
    <div className={styles.body}>
      <span className={styles.displayNameInput}>{displayNameInput}</span>
    </div>
  </li>
);

export default SubOfferingRow;
